import React from 'react';
import Immutable from 'immutable';

import {
  Container,
  Image,
} from '@uncinc/uncinc-react-kitchen-sink';

import '../style.scss';

const ParagraphImage = ({ entity }) => {
  const image = entity.getIn(['field_media_image', 0, 'styles'], Immutable.List());
  const imageStyle = image.get('paragraph_image');
  const imageStyleFullWidth = image.get('paragraph_image_original');
  const imageAlt = entity.getIn(['field_media_image', 0, 'alt'], '');
  const imageCaption = entity.getIn(['field_caption', 0, 'value']);
  const displayFullWidth = entity.getIn(['field_full_width', 0, 'value'], false);

  return (
    <Container className="Paragraph ParagraphImage">
      <div className="row">
        <div className="col-12 col-md-12 col-lg-8 offset-lg-2 ParagraphImage__wrapper">
          {imageStyle && (
            <Image
              className="ParagraphImage__image"
              src={displayFullWidth ? imageStyleFullWidth : imageStyle}
              alt={imageAlt}
            />
          )}

          {imageCaption && (
            <div className="ParagraphImage__caption">
              {imageCaption}
            </div>
          )}
        </div>
      </div>
    </Container>
  );
};

export default ParagraphImage;
